import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14m0-2A5 5 0 1 1 7 2a5 5 0 0 1 0 10M6 3v5h5a5 5 0 0 0-5-5"
    }, null, -1)
  ]))]))
}
export default { render: render }